import React from 'react';
import { Box, Button, Card, CardContent, FormControl, FormHelperText, IconButton, TextField, useTheme } from "@mui/material"
import NavBar from "../../../components/navbar/navbar"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Error } from "../offers/types";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL, sentActionLog, verify } from "../../../utils/common";
import { NotificationBroadcastResponse } from './types';
import swal from "sweetalert";

const Notifications: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const [error, setError] = React.useState<Error | undefined>(undefined);
    const [title, setTitle] = React.useState<string>('');
    const [message, setMessage] = React.useState<string>('');

    React.useEffect(() => {
        (async () => {
          if (!["/", "/login"].includes(location.pathname)) {
            const currentToken = localStorage.getItem("jwt");
            if (currentToken) {
              const isValid = await verify(currentToken);
              if (!isValid) {
                navigate("/");
              } else {
                const permissions = JSON.parse(
                  localStorage.getItem("user") || "{}"
                );
                if (!permissions?.administrationAccess) {
                  navigate("/Home");
                }
              }
            } else {
              navigate("/");
            }
          }
        })();
    }, [location.pathname, navigate]);

    const handleSend = () => {
        const token = localStorage.getItem("jwt");
        if(title && message){
            const data = {
                title,
                message,
                type: "INFO",
            }
            fetch(`${API_URL}/notificaciones/broadcast`, {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    Authorization: `bearer ${token}`,
                    "content-type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((response: NotificationBroadcastResponse) => {
                if (response.success) {
                    swal({
                        title: "Guardado!",
                        text: "Se ha guardado correctamente! :)",
                        icon: "success",
                    });
                    sentActionLog('Send_Notification', `Envio una nueva notificación masiva: ${data['message']}`);
                }
          })
          .catch((err) => {
            console.error(err);
          });
        } else {
            swal({
                title: "Ups!",
                text: "Titulo y mensaje no pueden estar vacios",
                icon: "warning",
            });
        }
    }

    return(
        <Box width={"100%"} mb={8}>
            <NavBar />
            <IconButton onClick={() => navigate(-1)}>
                <ArrowBackIcon />
            </IconButton>
            <Card sx={{ minWidth: 275 }}>
                <CardContent>
                    <FormControl fullWidth>
                        <TextField
                            error={error?.field === "title"}
                            style={{margin: theme.spacing(2) }}
                            color="secondary"
                            label="Titulo de Notificación"
                            variant="outlined"
                            value={title}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                setTitle(event.target.value);
                            }}
                        />
                        {error?.field === "title" && (
                            <FormHelperText>{error.message}</FormHelperText>
                        )}
                    </FormControl>
                    <FormControl fullWidth>
                        <TextField
                            error={error?.field === "message"}
                            style={{margin: theme.spacing(2) }}
                            color="secondary"
                            label="Mensaje de Notificación"
                            variant="outlined"
                            value={message}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                setMessage(event.target.value);
                            }}
                        />
                        {error?.field === "message" && (
                            <FormHelperText>{error.message}</FormHelperText>
                        )}
                    </FormControl>
                    <Button style={{margin: theme.spacing(2) }} variant="contained" color="secondary" onClick={handleSend}>
                        Enviar Notificación
                    </Button>
                </CardContent>
            </Card>
        </Box>
    )
}

export default Notifications